function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
/* import jwtDecode from 'jwt-decode'; */
import Cookies from 'js-cookie';
import { canUseDOM } from '../../utils';
var userCookieName = 'user_session';
var logoutState = {
  login_status: false
};
var errorState = {
  login_status: true,
  error: true
};
// const identityGlobal = canUseDOM ? get(window, 'identityGlobal', 'https://replaceidentityGlobal') : '';

export var setUserCookie = function setUserCookie(userObj) {
  var social = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var socialObj = social.length ? {
    social_login: true,
    social_platform: social
  } : {};
  var now = Date.now().valueOf() / 1000;
  var expiresAt = now + userObj.expires_in;
  var sessionObj = _objectSpread(_objectSpread({}, userObj), {}, {
    expires_at: expiresAt,
    login_status: true
  }, socialObj);
  Cookies.set(userCookieName, JSON.stringify(sessionObj), {
    expires: 30,
    secure: true
  });
  return sessionObj;
};
export var loaderToggle = function loaderToggle(toggle, btnStateDisable) {
  if (canUseDOM) {
    if (toggle) {
      btnStateDisable(true);
      document.body.classList.add('loader--show');
    } else {
      btnStateDisable(false);
      document.body.classList.remove('loader--show');
    }
  }
};

// Check if user has logged in returns cookie if its not expired
// if expired it fetches new token else return current token
// if gets successfully then set new token to cookie and returns it.
export var getLatestUserCookie = function getLatestUserCookie() {
  return new Promise(function (resolve) {
    var cookie = getUserCookie();
    var socialPlatform = '';
    if (cookie.social_platform) {
      socialPlatform = cookie.social_platform;
    }
    if (cookie.login_status) {
      var expired = isSessionExpired(cookie);
      if (expired) {
        updateUserSession(cookie).then(function (response) {
          if (response.access_token) {
            return resolve(setUserCookie(response, socialPlatform));
          } else {
            return resolve(response);
          }
        });
      } else {
        return resolve(cookie);
      }
    } else {
      return resolve(logoutState);
    }
  });
};

// return updated cookie regardless of expired or not
export var getUpdatedUserCookie = function getUpdatedUserCookie() {
  return new Promise(function (resolve) {
    var cookie = getUserCookie();
    var socialPlatform = '';
    if (cookie.social_platform) {
      socialPlatform = cookie.social_platform;
    }
    if (cookie.login_status) {
      updateUserSession(cookie).then(function (response) {
        if (response.access_token) {
          return resolve(setUserCookie(response, socialPlatform));
        } else {
          return resolve(response);
        }
      });
    } else {
      return resolve(logoutState);
    }
  });
};

// return current user cookie.
export var getUserCookie = function getUserCookie() {
  var parsedCookie,
    status = false;
  var cookie = Cookies.get(userCookieName);
  if (cookie) {
    try {
      parsedCookie = JSON.parse(cookie || '');
      if (parsedCookie.access_token) {
        status = true;
      }
    } catch (e) {}
  }
  if (status) {
    return parsedCookie;
  }
  return logoutState;
};

/* const jwtDecodeInternal = (token: any) => {
  try {
    return jwtDecode(token);
  } catch (error) {
    return logoutState;
  }
}; */

/* export const getJWTCookie = (cookie: any) => {
  return jwtDecodeInternal(cookie.access_token);
}; */

/* export const getJWT = (param: any) => {
  if (param.access_token) {
    return jwtDecodeInternal(param.access_token);
  } else {
    return jwtDecodeInternal(param);
  }
}; */

//
// Internal Functions
//

// Delete Cookie
export var deleteUserCookie = function deleteUserCookie() {
  var cookie = Cookies.get(userCookieName);
  if (cookie) {
    Cookies.remove(userCookieName);
  }
};

// Logout user
export var logoutUser = function logoutUser() {
  return new Promise(function (resolve) {
    var cookie = getUserCookie();

    // dont procede if no access_token or refresh_token in cookie
    if (!(cookie.refresh_token && cookie.access_token)) {
      resolve(false);
    }
    var myHeaders = new Headers();
    myHeaders.append('Authorization', "Bearer ".concat(cookie.access_token));
    myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    var urlencoded = new URLSearchParams();
    urlencoded.append('token', cookie.refresh_token);
    urlencoded.append('token_type_hint', 'refresh_token');
    urlencoded.append('client_id', clientId);
    urlencoded.append('client_secret', clientSecret);
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: urlencoded,
      redirect: 'follow'
    };
    var statusCode = 0;
    fetch("".concat(identityGlobal, "/connect/revocation"), requestOptions).then(function (response) {
      statusCode = response.status;
      return response.text();
    }).then(function (result) {
      var responseObj;
      if (result && result.length) {
        responseObj = JSON.parse(result);
      }
      if (statusCode === 200) {
        if (!result.length) {
          deleteUserCookie();
          resolve(true);
        } else {
          throw new Error('Could not logout');
        }
      } else {
        throw new Error('Could not logout');
      }
    }).catch(function (error) {
      resolve(false);
    });
  });
};

// to fetch new token through refresh token
export var updateUserSession = function updateUserSession(cookie) {
  var urlencoded = new URLSearchParams();
  urlencoded.append('grant_type', 'refresh_token');
  urlencoded.append('client_id', clientId);
  urlencoded.append('client_secret', clientSecret);
  urlencoded.append('scope', 'api.read    IdentityServerApi   offline_access');
  urlencoded.append('refresh_token', cookie.refresh_token);
  var myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
    redirect: 'follow'
  };
  var statusCode = 0;
  return fetch("".concat(identityGlobal, "/connect/token"), requestOptions).then(function (response) {
    statusCode = response.status;
    return response.text();
  }).then(function (result) {
    var responseObj;
    if (result) {
      responseObj = JSON.parse(result);
    }
    if (statusCode === 400) {
      if (responseObj.error) {
        throw Error(responseObj.error);
      }
    } else if (statusCode === 404) {
      throw Error('Invalid URL');
    } else if (statusCode === 200) {
      if (responseObj.access_token) {
        // setTimeout((responseObj) => {
        return responseObj;
        // }, 1000);
      }
    } else {
      throw Error("Unknown error, status ".concat(statusCode));
    }
  }).catch(function (error) {
    if (error.message === 'invalid_grant') {
      logoutUser();
      return logoutState;
    } else {
      return errorState;
    }
  });
};

// check using time if token has expired
export var isSessionExpired = function isSessionExpired(cookie) {
  var now = Date.now().valueOf() / 1000;
  var bufferSeconds = 60 * 7; // 7 seconds buffer before cookie expires
  var exp = cookie.expires_at - bufferSeconds;
  return now > exp;
};